export class Content_Block{
    constructor(type){
        this.type = type;
    }
}